<template>
  <div>
    <div class="about">
      <div class="header-image" :style="'background-image:url(' + featuredImage + ');'" v-if="featuredImage">
        <SubTopNav v-if="title" :title="title" />
      </div>
      <div v-else :class="'header-image default-header-' + rand">
        <SubTopNav v-if="title" :title="title" />
      </div>

      <div class="page-content">
        <div class="item-group-2">
          <div class="content-body item animated fadeInUp" v-for="(item, index) in contentBody" :key="index">
            <div class="body-row">
              <!-- {{ contentImages[index] }} -->

              <div v-if="index == 0">
                <h3>{{ tagline }}</h3>
                <div v-html="item.value"></div>
              </div>
              <div v-else v-html="item.value"></div>
            </div>
          </div>
          <div class="page-form">
            <iframe :src="baseAPI + '/webform/contact_us/share'" title="Contact Us | EKDIPA" class="webform-share-iframe" frameborder="0" allow="geolocation; microphone; camera" allowtransparency="true" allowfullscreen="true" style="width:100%;height:700px;border:none"></iframe>
          </div>
        </div>

        <div class="item-group">
          <div v-for="item in group" :key="item.nid" class="group-item animated fadeInUp" @click="toggleItem(item.nid)">
            <!-- {{ item }} -->
            <div class="img" v-if="item && item.field_photo"><img :src="baseDomain + item.field_photo" /></div>
            <div class="name">
              <h3 v-html="item.title"></h3>
            </div>
          </div>
        </div>
      </div>
      <div :class="['item-view', 'animated', showItem ? 'bounceInRight' : 'bounceOutRight']" v-show="showAnimation">
        <div class="item-close-icon" @click="toggleItem()"><i class="fas fa-times fa-2x"></i></div>
        <div class="img" v-if="selectedItem && selectedItem.field_photo"><img :src="baseDomain + selectedItem.field_photo" /></div>
        <h3 v-if="selectedItem && selectedItem.title">{{ selectedItem.title }}</h3>

        <div v-html="selectedItem.body"></div>
      </div>
    </div>
  </div>
</template>
<script>
// @ is an alias to /src
import { mapState } from "vuex"
import SubTopNav from "@/components/SubTopNav.vue"
import { RepositoryFactory } from "@/repositories/RepositoryFactory"
const ContentRepository = RepositoryFactory.get("content")

export default {
  name: "about",
  components: {
    SubTopNav,
  },
  data: function() {
    return {
      content: null,
      image: null,
      featuredImage: null,
      contentImages: [],
      group: [],
      contentBody: null,
      title: null,
      rand: 1,
      tagline: null,
      siblings: [],
      selectedItem: {},
      showItem: false,
      showAnimation: false,
    }
  },
  methods: {
    async getNode(id) {
      // var id = "2"
      const { data } = await ContentRepository.getNode(id)
      // console.log('home page data', data)

      this.title = data.title[0].value
      this.tagline = data.body[0].summary
      this.featuredImage = data.field_feature_image && data.field_feature_image[0] && data.field_feature_image[0].url ? data.field_feature_image[0].url : null
      this.contentImages = data.field_content_image_s_
      this.contentBody = data.body

      // this.getSiblings()
    },
    async getGroup(type) {
      const { data } = await ContentRepository.getGroup(type)
      this.group = data

      // this.getSiblings()
    },
    getItem(alias) {
      var aliasName = alias.split("/").pop()
      var path = "/sector/" + aliasName

      this.$router.push(path)
    },
    toggleItem(nid) {
      if (nid) {
        var selectedArray = this.group.filter(function(item) {
          return item.nid == nid
        })

        this.selectedItem = selectedArray[0]
        // this.selectedItem.content = this.selectedItem.body[0]
        this.showItem = true
        this.showAnimation = true
      } else {
        this.selectedItem = {}
        this.showItem = false
      }
    },
    // getSiblings(){
    // 	var navigation = this.$session.get('navigation')
    // 	var pageTitle = this.title.toLowerCase()
    // 	if (navigation && navigation.length){
    // 		var menuItemArr = navigation.filter(function (item){
    //         return item.name.toLowerCase() == pageTitle
    //       })

    //       var menuItem = menuItemArr[0]
    //       var menuParent = menuItem.parent

    //       if (menuParent){
    //       	var siblingsArr = navigation.filter(function (item){
    //       		return (item.parent == menuParent) && (item.name.toLowerCase() != pageTitle)
    //       	})

    //       	this.siblings = siblingsArr

    //       }

    //       // console.log('sub expertise', this.subExpertise)
    // 	}
    // }
  },
  mounted() {
    var api = this.$route.meta.api
    if (api && api.length && api.length > 0) {
      api.forEach((item) => {
        if (item.type == "node") {
          this.getNode(item.id)
        }
        if (item.type == "group") {
          this.getGroup(item.id)
        }
      })
      // if (api.type == "node"){
      // 	this.getNode(api.id)
      // } else if (api.type == "group") {
      // 	this.getGroup(api.id)
      // } else {

      // }
    }

    this.rand = Math.floor(Math.random() * 8) + 1
  },
  computed: {
    ...mapState(["baseDomain", "baseAPI"]),
  },
}
</script>
<style scoped>
.page-grid {
  display: grid;
  grid-template-columns: 1fr 1fr;
  grid-gap: 25px;
}

.about {
  overflow-x: hidden;
}

.page-grid .item {
  xbackground: #ccc;
  xpadding: 10px;
}

.page-grid .item:nth-child(1) {
  xborder: 1px solid red;
  grid-column: 1 / 3;
}

.page-grid .item:nth-child(1) .body-row {
  xdisplay: grid;
  xgrid-template-columns: 1fr 1fr;
  xborder: 10px solid #e1e1e1;
  xpadding: 25px;
  grid-gap: 25px;
  margin-top: 25px;
  margin-bottom: 25px;
  xborder-radius: 0px 0px 85px 0px;
}

/*.page-grid .item:nth-child(1) .body-row div:nth-child(1){
		padding:25px;
	}

	.page-grid .item:nth-child(1) .body-row div:nth-child(2) h3{
		margin-top:55px;
	}

	.page-grid .item:nth-child(1) .body-row div:nth-child(2){
		xpadding:25px;
	}

	.page-grid img{
		width:100%;
	}*/

.page-grid .item:nth-child(2) {
  border-top: 5px solid #cc0000;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(3) {
  border-top: 5px solid #663300;
  padding-top: 20px;
  margin-top: 20px;
}

.page-grid .item:nth-child(4) {
  xborder-top: 5px solid #339900;
  color: #fff;
  background: #339900;
  font-size: 120%;
  padding: 20px 320px;
  margin-left: -300px;
  margin-right: -300px;
  margin-top: 20px;
  grid-column: 1 / 3;
}

.page-content {
  text-align: left;
  xmargin-bottom: 30px;
}

.image-break {
  height: 300px;
  xbackground: #ccc;
  margin-top: 35px;
  margin-bottom: 35px;
}

.image-box {
  height: 300px;
  top: 0;
  left: 0;
  filter: grayscale(100%);
  xopacity: 0.3;
}

.image-text {
  margin-top: -300px;
  z-index: 50;
  position: relative;
}

.image-text a {
  color: #fff;
}

.image-text .container div {
  background: rgba(255, 102, 0, 0.8);
  color: #fff;
  padding: 105px 50px 50px 50px;
  float: left;
  width: 50%;
  height: 300px;
}

.page-content .content-body:nth-child(2n) .image-text .container div {
  float: right;
  background: rgba(102, 153, 51, 0.8);
}

.item-group {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr 1fr;
  grid-gap: 25px;
}

.group-item {
  xpadding: 25px;
  box-shadow: 3px 3px 5px #ccc;
  background-size: 25px;
  cursor: pointer;
  border-radius: 0 0 25px 0;
  margin-bottom: 40px;
}

.group-item .name {
  padding: 25px;
}

.page-subheader {
  margin-top: 40px;
}

.group-item img {
  width: 100%;
}

.group-item .img {
  height: 250px;
  overflow: hidden;
}

.body-row {
  xpadding: 25px;
}

.item-group-2 {
  display: grid;
  grid-template-columns: 1fr 2fr;
}

.item-view {
  position: fixed;
  right: 0;
  top: 0;
  height: 100vh;
  z-index: 100;
  width: 800px;
  max-width: 100%;
  text-align: left;
  color: #fff;
  padding: 50px;
  xoverflow-y: scroll;
  /*right:0;
		top:0;
		width:800px;
		max-width:100%;*/
  background: rgba(0, 115, 60, 0.9);
}

.item-view img {
  width: 300px;
  float: left;
  margin: 0 40px 20px 0;
}

.item-view div {
  margin-bottom: 30px;
}

.item-close-icon {
  float: right;
  cursor: pointer;
  margin-top: -40px;
  margin-right: -40px;
  margin-left: 15px;
}
</style>
